<template>
    <el-dialog
        class="detail-coupon"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Detail Coupon"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="detailForm"
                :model="detailForm"
                :rules="rules"
                label-width="80px"
                disabled
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Time" prop="time" size="small">
                            <el-date-picker
                                v-model="detailForm.time"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="Start Time"
                                end-placeholder="End Time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Title" prop="name" size="small">
                            <el-input
                                v-model="detailForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Discount" prop="value" size="small">
                            <el-input
                                v-model="detailForm.value"
                                placeholder="Please input value"
                                ><template slot="append">% off</template></el-input
                            >
                        </el-form-item>
                        <el-form-item label="Desc" prop="desc" size="small">
                            <el-input
                                type="textarea"
                                v-model="detailForm.desc"
                                placeholder="Please input desc"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                name: "",
                value: "",
                time: [],
                desc: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.detailForm = {
                name: "",
                value: "",
                time: [],
                desc: "",
            }
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        save() {
            this.$refs["detailForm"].validate((valid) => {
                if (valid) {
                    let time = JSON.parse(JSON.stringify(this.detailForm.time));
                    delete this.detailForm.time;
                    cmofferApi
                        .couponList(
                            {
                                ...this.detailForm,
                                start_time: time[0],
                                end_time: time[1],
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        couponList() {
            cmofferApi
                .couponList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.detailForm = { ...res.data, time: [res.data.start_time, res.data.end_time] };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        detailVisible(val) {
            if(val){
                this.couponList();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.detail-coupon {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
